<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span v-if="route.name == 'articleEdit'">Editar notícia</span>
        <span v-else>Nova notícia</span>
      </h1>
      <div class="d-flex">
        <PrimaryButton v-if="!loading && !notifications.messages" class="px-5" @click="verifyText()" :loading="isVerifyingText || processing" :disabled="isVerifyingText || processing" icon="fa-solid fa-paper-plane">
          <span v-if="isVerifyingText">Verificando...</span>
          <span v-else>Enviar</span>
        </PrimaryButton>

        <WhiteButton
          v-if="(article.status == 'pending' || article.status == 'refused' || article.status == 'draft' || !article.status) && !loading && !notifications.messages"
          class="ms-2 dropdown-toggle dropdown_button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </WhiteButton>

        <div class="dropdown">
          <ul class="dropdown-menu">
            <li v-if="article.status !== 'pending'"><a class="dropdown-item" @click="submit('draft')">Salvar
                rascunho</a></li>
            <li><a class="dropdown-item" @click="showScheduleModal = true">Agendar</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">

    <AlertMessages />

    <div v-if="articleCheck.length">
      <div class="card p-4 mb-4" id="article_check">
        <h6 class="mb-3"><i class="fa-regular fa-circle-exclamation me-1"></i> Revise os trechos
          abaixo e envie novamente</h6>
        <ul>
          <li v-for="(item, key) in articleCheck" :key="key" class="mt-2">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>

    <div class="col-12 mb-3" v-if="article.id">
      <span class="badge mb-1 me-2" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-animation="true"
        data-bs-html="true" v-tooltip title="Agendada"
        :style="'background-color: ' + article.status_color"><i
          v-if="article.status == 'pending' && article.schedule_date" class="fa-solid fa-clock me-1"></i>{{
        article.status_name }}</span>
      <span v-if="article.schedule_date" class="badge mb-1" style="background-color: #ed9f0a;">Agendada para {{
        $dateFormat(article.schedule_date) }}</span>
    </div>

    <div class="row">

      <div class="col-12 col-lg-8 mb-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <InputText label="Título" v-model="article.title" :error="formErrors.title" />
              </div>

              <div class="col-12 mb-3">
                <InputText label="Subtitulo" v-model="article.subtitle" :error="formErrors.subtitle" />
              </div>

              <div class="col-12 mb-1 references_multiple">
                <label>Links de fontes da notícia</label>

                <div class="mb-2 reference_item"
                  v-for="(reference, index) in article.references.filter(ref => ref.type === 'article')" :key="index">
                  <div class="d-flex"
                    v-if="(index + 1) === article.references.filter(ref => ref.type === 'article').length">
                    <InputText class="w-100" v-model="reference.url" :error="index === 0 ? formErrors.references_article : null" />
                    <PrimaryButton id="add_reference" @click="addReference('article')">+</PrimaryButton>
                  </div>

                  <div v-else>
                    <InputText class="w-100" v-model="reference.url" :error="index === 0 ? formErrors.references_article : null" />
                  </div>
                </div>
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Observações" v-model="article.observations" :error="formErrors.observations"
                  style="height: 90px" />
              </div>

              <div class="col-12 mb-3">
                <div class="counter">
                  {{ textLength }} caracteres
                </div>
                <ArticleEditor v-model="article.content" :idSite="article.id_site" :error="formErrors.content" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <SelectBox label="Site" id="form_sites" v-model="article.id_site" :error="formErrors.id_site"
                  placeholder="Selecione o site" :items="siteStore.sites" />
              </div>

              <div class="col-12 mb-3">
                <SelectBox label="Categoria" id="category" v-model="article.category" :error="formErrors.category"
                  placeholder="Selecione a categoria" :items="categories" />
              </div>

              <ImageUpload v-model="article.cover_image" :preview="article.cover_image_file_url"
                :error="formErrors.cover_image" />

              <div class="col-12 mb-4">
                <PrimaryButton class="w-100 mt-3" @click="showSearchImageModal = true">Buscar imagem</PrimaryButton>
              </div>

              <div class="col-12 mb-3">
                <InputText label="Créditos da imagem" v-model="article.cover_image_credits"
                  :error="formErrors.cover_image_credits" />
              </div>

              <div class="col-12 mb-2 references_multiple">
                <label>Links de fontes da imagem</label>

                <div class="mb-2 reference_item"
                  v-for="(reference, index) in article.references.filter(ref => ref.type === 'image')" :key="index">
                  <div class="d-flex"
                    v-if="(index + 1) === article.references.filter(ref => ref.type === 'image').length">
                    <InputText class="w-100" v-model="reference.url" :error="index === 0 ? formErrors.references_image : null" />
                    <PrimaryButton id="add_reference" @click="addReference('image')">+</PrimaryButton>
                  </div>

                  <div v-else>
                    <InputText class="w-100" v-model="reference.url" :error="index === 0 ? formErrors.references_image : null" />
                  </div>
                </div>
              </div>

              <div class="col-12">
                <InputTag label="Tags" v-model="article.tags" :error="formErrors.tags" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalDialog width="700px" title="Buscar imagem" v-model="showSearchImageModal">
    <InputText placeholder="Buscar..." v-model="searchImage" @keyup="debouncedSearchImages" />
    <div id="search_images" class="mt-3">
      <div class="row">
        <div class="image col-6 mb-3" v-for="(image, key) in images" :key="key">
          <img :src="image.cover_image"
            @click="selectImage(image.id, image.cover_image, image.cover_image_credits, image.cover_image_references)" />
          <small class="text-center d-block mt-2">{{ image.cover_image_credits }}</small>
        </div>
      </div>
    </div>
  </ModalDialog>

  <ModalDialog width="400px" title="Selecionar site" v-model="showSiteModal" overflow="inherit" forced="true">
    <SelectBox id="sites" v-model="article.id_site" :error="formErrors.id_site" placeholder="Selecione o site"
      :items="siteStore.sites" />
  </ModalDialog>

  <ModalDialog overflow="inherit" title="Agendar" v-model="showScheduleModal">
    <div class="row">
      <div class="col-6">
        <InputDatePicker v-model="scheduleArticle.date" placeholder="Data" />
      </div>
      <div class="col-6">
        <InputText type="time" v-model="scheduleArticle.time" placeholder="Horário" />
      </div>
    </div>

    <PrimaryButton @click="verifyText('schedule')" :loading="processing" :disabled="processing" class="mt-4 w-100">Enviar e agendar</PrimaryButton>
  </ModalDialog>

  <ModalDialog width="650px" title="Revisão de Texto" v-model="showSuggestionsModal">
    <div v-if="textSuggestions">
      <ul class="suggestions-list list-unstyled">
        <li 
          v-for="(suggestion, index) in formattedSuggestions" 
          :key="index"
          :class="{'suggestion-error': suggestion.includes('deve ser'), 'suggestion-improvement': suggestion.includes('ficaria melhor como')}"
        >
          <i
            :class="[suggestion.includes('deve ser') ? 'fa-solid fa-circle-exclamation text-danger me-2' : 'fa-regular fa-lightbulb text-warning me-2']"
          ></i>
          {{ suggestion }}
        </li>
      </ul>
    </div>
    <div v-else class="text-center">
      <i class="fa-regular fa-circle-check text-success fa-2x mb-2"></i>
      <p>Parabéns! Nenhuma sugestão de correção encontrada.</p>
    </div>
    <div class="d-flex justify-content-end mt-4">
      <WhiteButton class="me-2" @click="showSuggestionsModal = false">Corrigir texto</WhiteButton>
      <PrimaryButton @click="submit(submitFormType, true)" :loading="processing" :disabled="processing">Enviar mesmo assim</PrimaryButton>
    </div>
  </ModalDialog>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import WhiteButton from '@/components/WhiteButton.vue'
import InputText from '@/components/InputText.vue'
import InputTag from '@/components/InputTag.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import SelectBox from '@/components/SelectBox.vue'
import AlertMessages from '@/components/AlertMessages.vue'
import InputDatePicker from '@/components/InputDatePicker.vue'

import { inject, onBeforeMount, onMounted, ref, watch, computed } from 'vue'
import ImageUpload from '@/components/ImageUpload.vue'
import ArticleEditor from '@/components/ArticleEditor.vue'
import { useArticleStore } from '@/stores/ArticleStore'
import { useSiteStore } from '@/stores/SiteStore'

import { storeToRefs } from 'pinia'
import { useToast, TYPE } from "vue-toastification"
import { useRoute, useRouter } from 'vue-router'
import ModalDialog from '@/components/ModalDialog.vue'
import axios from 'axios'
import { useAuthStore } from '@/stores/AuthStore'
import TextArea from '@/components/TextArea.vue'
import {errorFormat} from "@/utils/errorFormat";
import { articleService } from '@/services/articleService';

const toast = useToast();
const loader = inject('$loader');
const loading = ref(false);
const processing = ref(false);

const router = useRouter();
const route = useRoute();

const articleStore = useArticleStore();
const { article, images } = storeToRefs(articleStore);

const siteStore = useSiteStore();

const authStore = useAuthStore();
const { notifications } = storeToRefs(authStore);

const categories = ref([]);
const textLength = ref(0);
const articleCheck = ref({});
const showSiteModal = ref(false);
const showScheduleModal = ref(false);
const scheduleArticle = ref({date: null, time: null});
const isVerifyingText = ref(false);
const showSuggestionsModal = ref(false);
const textSuggestions = ref(null);
const submitFormType = ref(null);

const formattedSuggestions = computed(() => {
  if (!textSuggestions.value) {
    return [];
  }
  return textSuggestions.value
    .split('\n')
    .map(line => line.trim().replace(/^-+\s*/, ''))
    .filter(line => line.length > 0);
});

onBeforeMount(async () => {
  article.value = {};
  article.value.references = [];
  images.value = {};
  siteStore.sites = {};
  loader.show();
  await siteStore.getSitesList();
  loader.hide();
});

onMounted(async () => {
  const id = route.params.id;
  if (route.name == 'articleEdit') {
    loader.show();
    loading.value = true;

    await articleStore.getArticle(id);

    textLength.value = extractText(article.value.content).length;

    loader.hide();
    loading.value = false;
  }else {
    showSiteModal.value = true;
  }

  if(!article.value.references.some(ref => ref.type === 'article')){
    article.value.references.push({type: 'article', url: null});
  }

  if(!article.value.references.some(ref => ref.type === 'image')){
    article.value.references.push({type: 'image', url: null});
  }

});

const extractText = (htmlString) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || "";
};

watch(() => article.value.content, (newValue) => {
  if (newValue) {
    textLength.value = extractText(newValue).length;
  }
}, { immediate: true });

watch(() => article.value.id_site, (value) => {

  if (value && siteStore.sites.length) {
    showSiteModal.value = false;
    const selectedSite = siteStore.sites.find(site => site.id === value);
    if (selectedSite && selectedSite.categories) {
      categories.value = selectedSite.categories;
    } else {
      categories.value = [];
    }
  } else {
    categories.value = [];
  }
}, { immediate: true });

const formErrors = ref({});

const submit = async (type = null, bypassVerification = false) => {
  if(processing.value == true){
    return;
  }

  if (!bypassVerification && !type) {
    await verifyText();
    return;
  }else {
    showSuggestionsModal.value = false;
    showScheduleModal.value = false;
  }

  let params = {
    title: article.value.title,
    subtitle: article.value.subtitle,
    references_image: article.value.references.filter(item => item.type === 'image').map(item => item.url),
    references_article: article.value.references.filter(item => item.type === 'article').map(item => item.url),
    content: article.value.content,
    id_site: article.value.id_site,
    category: article.value.category,
    tags: article.value.tags,
    cover_image: article.value.cover_image,
    cover_image_credits: article.value.cover_image_credits,
    cover_image_url: article.value.cover_image_url,
    id_selected_cover_image: article.value.id_selected_cover_image,
    observations: article.value.observations,
  };

  if (type == 'draft') {
    params.draft = true;
  }

  if (type == 'schedule') {
    params.schedule_date = scheduleArticle.value.date + ' ' + scheduleArticle.value.time;
  }

  loader.show();
  formErrors.value = {};
  processing.value = true;

  if (article.value.id) {
    const formResult = await articleStore.updateArticle(article.value.id, params);

    if (formResult.success) {

      if (type !== 'draft') {
          toast('Notícia enviada', { type: TYPE.SUCCESS, timeout: 6000 });
          router.push({ name: 'articles'});
      }else {
        toast('Notícia atualizada', { type: TYPE.SUCCESS, timeout: 6000 });
          router.push({ name: 'articles'});
      }
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
      checkErrorMessages(formErrors.value);

      if(formResult.message){
        toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
      }
    }
  }
  else {
    const formResult = await articleStore.addArticle(params);
    if (formResult.success) {
      if (type == 'draft') {
        toast('Rascunho salvo', { type: TYPE.SUCCESS, timeout: 6000 });
        router.push({ name: 'articles'});
      } else {
        toast('Notícia enviada', { type: TYPE.SUCCESS, timeout: 6000 });
        router.push({ name: 'articles' });
      }
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
      checkErrorMessages(formErrors.value);
      
      if(formResult.message){
        toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
      }
    }
  }

  showScheduleModal.value = false;

  processing.value = false;
  loader.hide();
};

const addReference = (type) => {
  if (article.value.references.length == 20) {
    return;
  }
  article.value.references.push({ type: type, url: '' });
};

const showSearchImageModal = ref(false);
let cancelTokenSource = null;
let searchImage = ref(null);

async function searchImages(event) {

  loader.show();
  articleStore.filter.page = parseInt(route.query.page);
  window.scrollTo(0, 0);

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  let params = {
    search: event.target.value,
  }

  let result = await articleStore.searchImages(params, cancelTokenSource);
  if (result.success) {
    loader.hide();
  }
}

const debouncedSearchImages = debounce(searchImages, 300);

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const selectImage = (id, coverImage, coverImageCredits, coverImageReferences) => {
  article.value.id_selected_cover_image = id;
  article.value.cover_image = null;
  article.value.cover_image_file_url = coverImage;
  article.value.cover_image_credits = coverImageCredits;
  article.value.cover_image_url = null;

  article.value.references = article.value.references.filter(reference => reference.type !== 'image');

  let netCoverImageReference = coverImageReferences.map(url => ({
    type: 'image',
    url: url
  }));

  article.value.references = [...article.value.references, ...netCoverImageReference];

  showSearchImageModal.value = false;
};

async function verifyText(type = null) {
  if (isVerifyingText.value || processing.value) {
    return;
  }
  
  isVerifyingText.value = true;
  textSuggestions.value = null;
  showScheduleModal.value = false;
  submitFormType.value = type;
  loader.show();

  try {
    let params = {
      title: article.value.title,
      subtitle: article.value.subtitle,
      content: article.value.content,
    }

    const response = await articleService.verifyText(params);
    if (response.data.suggestions && response.data.suggestions.trim() !== '' && response.data.suggestions.toLowerCase().indexOf('nenhum erro encontrado') === -1) {
      textSuggestions.value = response.data.suggestions;
      showSuggestionsModal.value = true;
    } else {
      await submit(type, true);
    }
  } catch (error) {
    await submit(type, true);
  } finally {
    isVerifyingText.value = false;
    loader.hide();
  }
}

function checkErrorMessages(errors) {
    const firstError = Object.keys(errors)[0];
    if(firstError) {
        const element = document.querySelector(`[name="${firstError}"], #${firstError}`);
        if(element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
</script>

<style scoped>
#add_reference {
  height: 43px;
  margin-left: 10px;
}

.counter {
  display: inline-block;
  background-color: #583a8e;
  padding: 2px 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #fff;
}

#search_images .image img {
  width: 100%;
  cursor: pointer;
}

#search_images .image:hover {
  opacity: 0.5;
}

#search_images {
  max-height: 510px;
  overflow-y: auto;
  overflow-x: hidden;
}

#add_reference {
  margin-top: 4px;
}

.reference_item:first-child #add_reference {
  margin-top: 25px;
}

.alert {
  background-color: #f6aa10;
}

#article_check {
  border: 2px #dda40e solid;
}

#article_check ul {
  padding: 0;
  margin-bottom: 0;
}

#article_check ul li {
  background-color: #ececec;
  padding: 15px;
  border-radius: 6px;
  list-style: none;
  border: 0;
  font-weight: 500;
}

.dark #article_check ul li {
  background-color: #1b2127;
}

.dropdown_button::after {
  display: none;
}

.suggestions-list li {
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 8px;
  border: 1px solid #dee2e6;
}

.dark .suggestions-list li {
  background-color: #2a2a2a;
  border-color: #444;
  color: #e0e0e0;
}

.dark .suggestions-list li .text-success {
  color: #6bc88b !important;
}
</style>